<template>
    <form class="item-editor-form">
        <fg-input v-model="item.id" :label="$t('users.id')" :disabled="action == 'edit'" @input="validateId" :class="{ 'is-invalid': idError }" pattern="[0-9]*" inputmode="numeric"></fg-input>
        <div v-if="idError" class="invalid-feedback">{{ $t('users.id_numeric_only') }}</div>
        <fg-input v-model="item.description" :label="$t('users.description')"></fg-input>
 
        <b-table 
            :items="userGroupParameters" 
            :fields="fields">

            <template v-slot:cell(value)="{ item, field: { key } }">
                <b-form-group v-if="item.name === 'PRIMARY_LANGUAGE'">
                    <languageSelect v-model="item.value" id="language"/>
                </b-form-group>
                <b-form-group v-else>
                    <input type="text" class="form-control" v-model="item[key]">
                </b-form-group>
            </template>
            
        </b-table>        
        
        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeUpdate('system', 'usergroups')"  
            :reset="false" 
            :remove="action == 'item' && $UIPrivilegeDelete('system', 'usergroups')"
            :itemid="item.description"
            @remove="remove">
        </FormButtons>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

    </form> 	
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import languageSelect from '@/components/System/LanguageSelect'

export default {
    components: { FormButtons, languageSelect },
    props: {
        item: { default: {} },
        action: { default: "new" }
    },
    data () {
        return {
            fields: [
                { key: "description", label: "",
                    formatter: (value, key, item) => {
                    return this.$t(item.description);
                    }
                },
                { key: "value", label: "" },
            ],
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            errorMsg: "",
            userGroupParameters: [],
            showErrors: true,
            idError: false
        }
    },
    created() {
        this.getUserGroupParameters(this.item.id);
    },
    watch: {
        item: function(item) {
            if (this.action !== 'new')
                this.getUserGroupParameters(item.id);
            this.ok = this.error = this.loading = false;  
        },        
    }, 
    methods: {
        getUserGroupParameters(item) {
            this.$store.dispatch('userDataHandler/getUserGroup' , item ).then( response => {
                this.userGroupParameters = response.data.parameters;
            });                
        },
        validateId(value) {
            this.idError = !/^\d*$/.test(value);
            if (this.idError) {
                this.item.id = value.replace(/\D/g, '');
            }
        },
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            this.item.parameters = this.userGroupParameters;

            setTimeout(() => { 
                if (this.action === 'new') {
                    for (var parameter of this.userGroupParameters) {
                        parameter.parameterOwnerId = this.item.id;
                    } 
                }
                this.$store.dispatch('userDataHandler/updateUserGroup' , this.item).then(response => {
                    this.ok = response.data.errorCode === 0;
                    if (this.ok) {
                        this.$store.dispatch('userDataHandler/saveUserGroupParameters' , this.userGroupParameters, this.item.id).then(response => {
                        this.ok = response.data.errorCode === 0;
                        this.error = !this.ok;
                    })
                    .catch( () => { 
                        this.error = true; 
                    }) 
                    .finally(() => {
                        this.loading = false;
                        this.$emit('updateItem', this.item);
                    })

                    }
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        reset(event){
            event.preventDefault();  
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('userDataHandler/deleteUserGroup' , this.item.id).then(response => {
                    this.ok = response.data.errorCode === 0;
                    if (this.ok) this.$travellerRemoved();
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
  }
}
</script>

